// Authentication Action Types
export const AUTH_ACTION_TYPES = {
  // Login actions
  LOGIN_REQUEST: "AUTH/LOGIN_REQUEST",
  LOGIN_SUCCESS: "AUTH/LOGIN_SUCCESS",
  LOGIN_FAILURE: "AUTH/LOGIN_FAILURE",
  
  // Register actions
  REGISTER_REQUEST: "AUTH/REGISTER_REQUEST",
  REGISTER_SUCCESS: "AUTH/REGISTER_SUCCESS",
  REGISTER_FAILURE: "AUTH/REGISTER_FAILURE",
  
  // Logout actions
  LOGOUT_REQUEST: "AUTH/LOGOUT_REQUEST",
  LOGOUT_SUCCESS: "AUTH/LOGOUT_SUCCESS",
  LOGOUT_FAILURE: "AUTH/LOGOUT_FAILURE",
  
  
  // Forgot password actions
  FORGOT_PASSWORD_REQUEST: "AUTH/FORGOT_PASSWORD_REQUEST",
  FORGOT_PASSWORD_SUCCESS: "AUTH/FORGOT_PASSWORD_SUCCESS",
  FORGOT_PASSWORD_FAILURE: "AUTH/FORGOT_PASSWORD_FAILURE",
  
  // Reset password actions
  RESET_PASSWORD_REQUEST: "AUTH/RESET_PASSWORD_REQUEST",
  RESET_PASSWORD_SUCCESS: "AUTH/RESET_PASSWORD_SUCCESS",
  RESET_PASSWORD_FAILURE: "AUTH/RESET_PASSWORD_FAILURE",
  
  // Email verification actions
  VERIFY_EMAIL_REQUEST: "AUTH/VERIFY_EMAIL_REQUEST",
  VERIFY_EMAIL_SUCCESS: "AUTH/VERIFY_EMAIL_SUCCESS",
  VERIFY_EMAIL_FAILURE: "AUTH/VERIFY_EMAIL_FAILURE",
  
  // Username check actions
  CHECK_USERNAME_REQUEST: "AUTH/CHECK_USERNAME_REQUEST",
  CHECK_USERNAME_SUCCESS: "AUTH/CHECK_USERNAME_SUCCESS",
  CHECK_USERNAME_FAILURE: "AUTH/CHECK_USERNAME_FAILURE",
  
  // General auth actions
  CLEAR_AUTH_ERRORS: "AUTH/CLEAR_AUTH_ERRORS",
  SET_AUTH_STATUS: "AUTH/SET_AUTH_STATUS",
  // Reset state action
  RESET_STATE: "AUTH/RESET_STATE",
};

// User Action Types
export const USER_ACTION_TYPES = {
  // Fetch user actions
  FETCH_USER_REQUEST: "USER/FETCH_USER_REQUEST",
  FETCH_USER_SUCCESS: "USER/FETCH_USER_SUCCESS",
  FETCH_USER_FAILURE: "USER/FETCH_USER_FAILURE",
  
  // Update user actions
  UPDATE_USER_REQUEST: "USER/UPDATE_USER_REQUEST",
  UPDATE_USER_SUCCESS: "USER/UPDATE_USER_SUCCESS",
  UPDATE_USER_FAILURE: "USER/UPDATE_USER_FAILURE",
  
  // Delete user actions
  DELETE_USER_REQUEST: "USER/DELETE_USER_REQUEST",
  DELETE_USER_SUCCESS: "USER/DELETE_USER_SUCCESS",
  DELETE_USER_FAILURE: "USER/DELETE_USER_FAILURE",
  
  // General user actions
  CLEAR_USER_ERRORS: "USER/CLEAR_USER_ERRORS",
  SET_USER_DATA: "USER/SET_USER_DATA",
};

// Creator Action Types
export const CREATOR_ACTION_TYPES = {
  // Fetch creator actions
  FETCH_CREATOR_REQUEST: "CREATOR/FETCH_CREATOR_REQUEST",
  FETCH_CREATOR_SUCCESS: "CREATOR/FETCH_CREATOR_SUCCESS",
  FETCH_CREATOR_FAILURE: "CREATOR/FETCH_CREATOR_FAILURE",
  
  // Update creator actions
  UPDATE_CREATOR_REQUEST: "CREATOR/UPDATE_CREATOR_REQUEST",
  UPDATE_CREATOR_SUCCESS: "CREATOR/UPDATE_CREATOR_SUCCESS",
  UPDATE_CREATOR_FAILURE: "CREATOR/UPDATE_CREATOR_FAILURE",
  
  // Delete creator actions
  DELETE_CREATOR_REQUEST: "CREATOR/DELETE_CREATOR_REQUEST",
  DELETE_CREATOR_SUCCESS: "CREATOR/DELETE_CREATOR_SUCCESS",
  DELETE_CREATOR_FAILURE: "CREATOR/DELETE_CREATOR_FAILURE",
  
  // General creator actions
  CLEAR_CREATOR_ERRORS: "CREATOR/CLEAR_CREATOR_ERRORS",
  SET_CREATOR_DATA: "CREATOR/SET_CREATOR_DATA",
};

// File Action Types
export const FILE_ACTION_TYPES = {
  // Get presigned URL actions
  GET_PRESIGNED_URL_REQUEST: "FILE/GET_PRESIGNED_URL_REQUEST",
  GET_PRESIGNED_URL_SUCCESS: "FILE/GET_PRESIGNED_URL_SUCCESS",
  GET_PRESIGNED_URL_FAILURE: "FILE/GET_PRESIGNED_URL_FAILURE",
  
  // Get presigned URL without auth actions
  GET_PRESIGNED_URL_WITHOUT_AUTH_REQUEST: "FILE/GET_PRESIGNED_URL_WITHOUT_AUTH_REQUEST",
  GET_PRESIGNED_URL_WITHOUT_AUTH_SUCCESS: "FILE/GET_PRESIGNED_URL_WITHOUT_AUTH_SUCCESS",
  GET_PRESIGNED_URL_WITHOUT_AUTH_FAILURE: "FILE/GET_PRESIGNED_URL_WITHOUT_AUTH_FAILURE",
  
  // Get signed URLs actions
  GET_SIGNED_URLS_REQUEST: "FILE/GET_SIGNED_URLS_REQUEST",
  GET_SIGNED_URLS_SUCCESS: "FILE/GET_SIGNED_URLS_SUCCESS",
  GET_SIGNED_URLS_FAILURE: "FILE/GET_SIGNED_URLS_FAILURE",
  
  // Get multipart presigned URLs actions
  GET_MULTIPART_PRESIGNED_URLS_REQUEST: "FILE/GET_MULTIPART_PRESIGNED_URLS_REQUEST",
  GET_MULTIPART_PRESIGNED_URLS_SUCCESS: "FILE/GET_MULTIPART_PRESIGNED_URLS_SUCCESS",
  GET_MULTIPART_PRESIGNED_URLS_FAILURE: "FILE/GET_MULTIPART_PRESIGNED_URLS_FAILURE",
  
  // Upload part actions
  UPLOAD_PART_REQUEST: "FILE/UPLOAD_PART_REQUEST",
  UPLOAD_PART_SUCCESS: "FILE/UPLOAD_PART_SUCCESS",
  UPLOAD_PART_FAILURE: "FILE/UPLOAD_PART_FAILURE",
  
  // Complete multipart upload actions
  COMPLETE_MULTIPART_UPLOAD_REQUEST: "FILE/COMPLETE_MULTIPART_UPLOAD_REQUEST",
  COMPLETE_MULTIPART_UPLOAD_SUCCESS: "FILE/COMPLETE_MULTIPART_UPLOAD_SUCCESS",
  COMPLETE_MULTIPART_UPLOAD_FAILURE: "FILE/COMPLETE_MULTIPART_UPLOAD_FAILURE",
  
  // General file actions
  CLEAR_FILE_ERRORS: "FILE/CLEAR_FILE_ERRORS",
  SET_FILE_UPLOAD_PROGRESS: "FILE/SET_FILE_UPLOAD_PROGRESS",
};

// Notification Action Types
export const NOTIFICATION_ACTION_TYPES = {
  // Fetch notification count actions
  FETCH_NOTIFICATION_COUNT_REQUEST: "NOTIFICATION/FETCH_NOTIFICATION_COUNT_REQUEST",
  FETCH_NOTIFICATION_COUNT_SUCCESS: "NOTIFICATION/FETCH_NOTIFICATION_COUNT_SUCCESS",
  FETCH_NOTIFICATION_COUNT_FAILURE: "NOTIFICATION/FETCH_NOTIFICATION_COUNT_FAILURE",
  /** Clears footer badge locally without bumping syncRevision (opening Activity). */
  CLEAR_NOTIFICATION_COUNT: "NOTIFICATION/CLEAR_NOTIFICATION_COUNT",
};

// Message Action Types
export const MESSAGE_ACTION_TYPES = {
  // Fetch message count actions
  FETCH_MESSAGE_COUNT_REQUEST: "MESSAGE/FETCH_MESSAGE_COUNT_REQUEST",
  FETCH_MESSAGE_COUNT_SUCCESS: "MESSAGE/FETCH_MESSAGE_COUNT_SUCCESS",
  FETCH_MESSAGE_COUNT_FAILURE: "MESSAGE/FETCH_MESSAGE_COUNT_FAILURE",
  
  // Reset message count action
  RESET_MESSAGE_COUNT: "MESSAGE/RESET_MESSAGE_COUNT",
};

// Promotion Action Types
export const PROMOTION_ACTION_TYPES = {
  // Fetch promotion data actions
  FETCH_PROMOTION_REQUEST: "PROMOTION/FETCH_PROMOTION_REQUEST",
  FETCH_PROMOTION_SUCCESS: "PROMOTION/FETCH_PROMOTION_SUCCESS",
  FETCH_PROMOTION_FAILURE: "PROMOTION/FETCH_PROMOTION_FAILURE",
  
  // Clear promotion errors
  CLEAR_PROMOTION_ERRORS: "PROMOTION/CLEAR_PROMOTION_ERRORS",
};

// Content Action Types
export const CONTENT_ACTION_TYPES = {
  // Fetch feed actions
  FETCH_FEED_REQUEST: "CONTENT/FETCH_FEED_REQUEST",
  FETCH_FEED_SUCCESS: "CONTENT/FETCH_FEED_SUCCESS",
  FETCH_FEED_FAILURE: "CONTENT/FETCH_FEED_FAILURE",
  
  // Fetch purchased content actions
  FETCH_PURCHASED_CONTENT_REQUEST: "CONTENT/FETCH_PURCHASED_CONTENT_REQUEST",
  FETCH_PURCHASED_CONTENT_SUCCESS: "CONTENT/FETCH_PURCHASED_CONTENT_SUCCESS",
  FETCH_PURCHASED_CONTENT_FAILURE: "CONTENT/FETCH_PURCHASED_CONTENT_FAILURE",
  
  // Update feed content
  UPDATE_FEED_ITEM: "CONTENT/UPDATE_FEED_ITEM",
  
  // Clear content errors
  CLEAR_CONTENT_ERRORS: "CONTENT/CLEAR_CONTENT_ERRORS",
};

// Discover Screen Action Types
export const DISCOVER_ACTION_TYPES = {
  // Fetch featured profiles actions
  FETCH_FEATURED_PROFILES_REQUEST: "DISCOVER/FETCH_FEATURED_PROFILES_REQUEST",
  FETCH_FEATURED_PROFILES_SUCCESS: "DISCOVER/FETCH_FEATURED_PROFILES_SUCCESS",
  FETCH_FEATURED_PROFILES_FAILURE: "DISCOVER/FETCH_FEATURED_PROFILES_FAILURE",
  
  // Fetch all creators actions
  FETCH_ALL_CREATORS_REQUEST: "DISCOVER/FETCH_ALL_CREATORS_REQUEST",
  FETCH_ALL_CREATORS_SUCCESS: "DISCOVER/FETCH_ALL_CREATORS_SUCCESS",
  FETCH_ALL_CREATORS_FAILURE: "DISCOVER/FETCH_ALL_CREATORS_FAILURE",
  
  // Fetch categories actions
  FETCH_CATEGORIES_REQUEST: "DISCOVER/FETCH_CATEGORIES_REQUEST",
  FETCH_CATEGORIES_SUCCESS: "DISCOVER/FETCH_CATEGORIES_SUCCESS",
  FETCH_CATEGORIES_FAILURE: "DISCOVER/FETCH_CATEGORIES_FAILURE",
  
  // Fetch recommended profiles actions
  FETCH_RECOMMENDED_PROFILES_REQUEST: "DISCOVER/FETCH_RECOMMENDED_PROFILES_REQUEST",
  FETCH_RECOMMENDED_PROFILES_SUCCESS: "DISCOVER/FETCH_RECOMMENDED_PROFILES_SUCCESS",
  FETCH_RECOMMENDED_PROFILES_FAILURE: "DISCOVER/FETCH_RECOMMENDED_PROFILES_FAILURE",
  
  // Fetch trending profiles actions
  FETCH_TRENDING_PROFILES_REQUEST: "DISCOVER/FETCH_TRENDING_PROFILES_REQUEST",
  FETCH_TRENDING_PROFILES_SUCCESS: "DISCOVER/FETCH_TRENDING_PROFILES_SUCCESS",
  FETCH_TRENDING_PROFILES_FAILURE: "DISCOVER/FETCH_TRENDING_PROFILES_FAILURE",
  
  // Update follow status
  UPDATE_FOLLOW_STATUS: "DISCOVER/UPDATE_FOLLOW_STATUS",
  
  // Set pagination
  SET_CATEGORY_PAGE: "DISCOVER/SET_CATEGORY_PAGE",
  SET_RECOMMENDED_PAGE: "DISCOVER/SET_RECOMMENDED_PAGE",
  
  // Set auth state
  SET_AUTH_STATE: "DISCOVER/SET_AUTH_STATE",
  
  // Clear discover data
  CLEAR_DISCOVER_DATA: "DISCOVER/CLEAR_DISCOVER_DATA",
};

// Transaction Action Types
export const TRANSACTION_ACTION_TYPES = {
  // Lookup user actions
  LOOKUP_USER_REQUEST: "TRANSACTION/LOOKUP_USER_REQUEST",
  LOOKUP_USER_SUCCESS: "TRANSACTION/LOOKUP_USER_SUCCESS",
  LOOKUP_USER_FAILURE: "TRANSACTION/LOOKUP_USER_FAILURE",
  
  // List services actions
  LIST_SERVICES_REQUEST: "TRANSACTION/LIST_SERVICES_REQUEST",
  LIST_SERVICES_SUCCESS: "TRANSACTION/LIST_SERVICES_SUCCESS",
  LIST_SERVICES_FAILURE: "TRANSACTION/LIST_SERVICES_FAILURE",
  
  // Clear transaction errors
  CLEAR_TRANSACTION_ERRORS: "TRANSACTION/CLEAR_TRANSACTION_ERRORS",
};

// Credit Action Types
export const CREDIT_ACTION_TYPES = {
  // Fetch credit list actions
  FETCH_CREDIT_LIST_REQUEST: 'CREDIT/FETCH_CREDIT_LIST_REQUEST',
  FETCH_CREDIT_LIST_SUCCESS: 'CREDIT/FETCH_CREDIT_LIST_SUCCESS',
  FETCH_CREDIT_LIST_FAILURE: 'CREDIT/FETCH_CREDIT_LIST_FAILURE',

  // Fetch wallet balance actions
  FETCH_WALLET_BALANCE_REQUEST: 'CREDIT/FETCH_WALLET_BALANCE_REQUEST',
  FETCH_WALLET_BALANCE_SUCCESS: 'CREDIT/FETCH_WALLET_BALANCE_SUCCESS',
  FETCH_WALLET_BALANCE_FAILURE: 'CREDIT/FETCH_WALLET_BALANCE_FAILURE',

  // Clear credit errors
  CLEAR_CREDIT_ERRORS: 'CREDIT/CLEAR_CREDIT_ERRORS',
};

// Activity (creator notifications) action types
export const ACTIVITY_ACTION_TYPES = {
  TAB_REQUEST: 'ACTIVITY/TAB_REQUEST',
  TAB_SUCCESS: 'ACTIVITY/TAB_SUCCESS',
  TAB_FAILURE: 'ACTIVITY/TAB_FAILURE',
  ITEM_VIEWED: 'ACTIVITY/ITEM_VIEWED',
  RESET_UNREAD_COUNTS: 'ACTIVITY/RESET_UNREAD_COUNTS',
};

// Tip action types (creator message tips earnings, etc.)
export const TIP_ACTION_TYPES = {
  FETCH_MESSAGE_TIPS_EARNINGS_REQUEST: 'TIP/FETCH_MESSAGE_TIPS_EARNINGS_REQUEST',
  FETCH_MESSAGE_TIPS_EARNINGS_SUCCESS: 'TIP/FETCH_MESSAGE_TIPS_EARNINGS_SUCCESS',
  FETCH_MESSAGE_TIPS_EARNINGS_FAILURE: 'TIP/FETCH_MESSAGE_TIPS_EARNINGS_FAILURE',
  CLEAR_TIP_ERRORS: 'TIP/CLEAR_TIP_ERRORS',
};

// Matrix Action Types
export const MATRIX_ACTION_TYPES = {
  // Fetch rooms actions
  FETCH_MATRIX_ROOMS_REQUEST: "MATRIX/FETCH_MATRIX_ROOMS_REQUEST",
  FETCH_MATRIX_ROOMS_SUCCESS: "MATRIX/FETCH_MATRIX_ROOMS_SUCCESS",
  FETCH_MATRIX_ROOMS_FAILURE: "MATRIX/FETCH_MATRIX_ROOMS_FAILURE",
  /** Drops stuck loading flags when a fetch never settles (silent; no user-facing error). */
  FETCH_MATRIX_ROOMS_STALE_ABORT: "MATRIX/FETCH_MATRIX_ROOMS_STALE_ABORT",

  // Fetch all rooms actions (New Message page)
  FETCH_MATRIX_ALL_ROOMS_REQUEST: "MATRIX/FETCH_MATRIX_ALL_ROOMS_REQUEST",
  FETCH_MATRIX_ALL_ROOMS_SUCCESS: "MATRIX/FETCH_MATRIX_ALL_ROOMS_SUCCESS",
  FETCH_MATRIX_ALL_ROOMS_FAILURE: "MATRIX/FETCH_MATRIX_ALL_ROOMS_FAILURE",
  FETCH_MATRIX_ALL_ROOMS_STALE_ABORT: "MATRIX/FETCH_MATRIX_ALL_ROOMS_STALE_ABORT",

  // Fetch room info actions (by destination user id)
  FETCH_MATRIX_ROOM_INFO_REQUEST: "MATRIX/FETCH_MATRIX_ROOM_INFO_REQUEST",
  FETCH_MATRIX_ROOM_INFO_SUCCESS: "MATRIX/FETCH_MATRIX_ROOM_INFO_SUCCESS",
  FETCH_MATRIX_ROOM_INFO_FAILURE: "MATRIX/FETCH_MATRIX_ROOM_INFO_FAILURE",

  // Fetch restricted words actions
  FETCH_RESTRICTED_WORDS_REQUEST: "MATRIX/FETCH_RESTRICTED_WORDS_REQUEST",
  FETCH_RESTRICTED_WORDS_SUCCESS: "MATRIX/FETCH_RESTRICTED_WORDS_SUCCESS",
  FETCH_RESTRICTED_WORDS_FAILURE: "MATRIX/FETCH_RESTRICTED_WORDS_FAILURE",
  
  // Clear matrix errors
  CLEAR_MATRIX_ERRORS: "MATRIX/CLEAR_MATRIX_ERRORS",
};
